// Evidence links arrive as app-relative signed redirect paths (`/files/…` in production, the Rails
// default elsewhere), valid for an hour from the response that carried them. They are resolved
// against the API origin at render time and never persisted: a stored link is a dead link.
// Lives outside the services module on purpose: component tests automock that module, and a helper
// there would render `href={undefined}` under test.
const ABSOLUTE = /^https?:\/\//i

export const evidenceUrl = path => {
  if (typeof path !== 'string' || path === '') return null
  if (ABSOLUTE.test(path)) return path
  const base = (process.env.REACT_APP_PLATFORM_URL || '').replace(/\/+$/, '')
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`
}
